import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { DoverSidebar, DoverHeader, Footer } from '../../layout-components';

import { PHASE_0_TIMESPAN, PHASE_1_TIMESPAN, PHASE_2_TIMESPAN } from '../../example-pages/SplashScreen/GlobalSplashScreen';

const previousPage = document.referrer;

const DoverLeftSidebar = (props) => {
  const {
    children,
    sidebarToggle,
    sidebarToggleMobile,
    sidebarFixed,
    headerFixed,
    headerSearchHover,
    headerDrawerToggle,
    footerFixed,
    contentBackground
  } = props;

  const [splashMode, setSplashMode] = useState(true);

  useEffect(() => {
    let mounted = true;

    if (previousPage.indexOf(document.location.hostname) === -1) {
      setTimeout(() => {
        if (mounted) {
          setSplashMode(splashMode => false);
          window.globalSplashEnded = true;
        }
      }, PHASE_0_TIMESPAN + PHASE_1_TIMESPAN + PHASE_2_TIMESPAN)
    }

    return () => { }
  }, []);

  return (
    <>
      <div
        className={clsx('app-wrapper', contentBackground, {
          'header-drawer-open': headerDrawerToggle,
          'app-sidebar-collapsed': sidebarToggle,
          'app-sidebar-mobile-open': sidebarToggleMobile,
          'app-sidebar-fixed': sidebarFixed,
          'app-header-fixed': headerFixed,
          'app-footer-fixed': footerFixed,
          'search-wrapper-open': headerSearchHover
        })}>

        <div>
          {splashMode && !window.globalSplashEnded && (previousPage.indexOf(document.location.hostname) === -1) ? '' : <DoverSidebar />}
        </div>
        <div className="app-main bg-tactical-khaki">
          {splashMode && !window.globalSplashEnded && (previousPage.indexOf(document.location.hostname) === -1) ? '' : <DoverHeader />}
          <div className="app-content">
            <div className="app-content--inner">
              <div className="app-content--inner__wrapper">{children}</div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

DoverLeftSidebar.propTypes = {
  children: PropTypes.node
};

const mapStateToProps = (state) => ({
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
  sidebarFixed: state.ThemeOptions.sidebarFixed,
  headerFixed: state.ThemeOptions.headerFixed,
  headerSearchHover: state.ThemeOptions.headerSearchHover,
  headerDrawerToggle: state.ThemeOptions.headerDrawerToggle,

  footerFixed: state.ThemeOptions.footerFixed,

  contentBackground: state.ThemeOptions.contentBackground
});

export default connect(mapStateToProps)(DoverLeftSidebar);
